import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { PackagesProvider } from 'leash/context/packages/PackagesContext';
import Archived from 'leash/pages/archived/Archived';
import { Details } from 'leash/pages/details/Details';
import { Packages } from 'leash/pages/packages/Packages';
import { LeashRoutes } from 'leash/utilities/const';
import { useUserCapabilities } from 'shared/hooks';
import { UserCapabilities } from 'utilities/const';

export const Travel = (): ReactElement | null => {
  const { capabilities, loadingCapabilities } = useUserCapabilities();

  if (loadingCapabilities) return null;

  return capabilities.includes(UserCapabilities.UseLeashApp) ? (
    <PackagesProvider>
      <Switch>
        <Route path={LeashRoutes.Archived} exact={true} component={Archived} />
        <Route path={`${LeashRoutes.Packages}/:category?/:query?`} component={Packages} />
        <Route
          path={`${LeashRoutes.Details}/:orderId`}
          exact={true}
          component={Details}
        />
      </Switch>
    </PackagesProvider>
  ) : (
    <Switch>
      <Redirect to="/dashboard" />
    </Switch>
  );
};
